import 'whatwg-fetch';
import API, { GET_AUTH_ROOMS } from 'base/api';
import auth, { STORAGE_ROOMS_TOKEN } from 'base/auth';

export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const FETCH_USER_DATA_BEGIN = 'FETCH_USER_DATA_BEGIN';
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_ERROR = 'FETCH_USER_DATA_ERROR';

export const fetchUserDataBegin = () => ({
    type: FETCH_USER_DATA_BEGIN
});

export const fetchUserDataSuccess = ( data ) => ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: { data }
});

export const fetchUserDataError = ( error ) => ({
    type: FETCH_USER_DATA_ERROR,
    payload: { error }
});

export function fetchUserData (token){
    return dispatch => {

      dispatch(fetchUserDataBegin());
      return fetch(API.GET_STUDENT, {
          method: 'GET',
          headers: new Headers({
              'Content-Type': 'application/json',
              "Authorization": auth.getToken(STORAGE_ROOMS_TOKEN) ? auth.getToken(STORAGE_ROOMS_TOKEN) : token
          })
      })
        .then(handleErrors)
        .then(res => res.json())
        .then(json => {
          dispatch(fetchUserDataSuccess(json));
          return json;
        })
        .catch(error => dispatch(fetchUserDataError(error.message)));
    };
  }

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }



// WEBPACK FOOTER //
// ./src/modules/User/redux/fetchUserData.js